import { GOOGLE_MAPS_LOADED } from 'actions/types';

const initialState = { googleMapsLoaded: false, craftyClicksLoaded: false };
const locationProvider = (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case GOOGLE_MAPS_LOADED:
      return {
        ...state,
        googleMapsLoaded: action.payload ?? true,
      };

    default:
      return state;
  }
};

export default locationProvider;
